import { Heading, VStack } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { IActivity } from '../../../../../packages/api/types';
import { useTheme } from '../../../../../packages/ui/contexts/ThemeProvider';
import useIsMobile from '../../useIsMobile';

export function BookActivityCard({ activity }: { activity: IActivity }) {
  const { isNative, bookstoreTypes } = useTheme();
  const isMobile = useIsMobile();

  const urlName = bookstoreTypes.includes('magazine') ? 'banca' : 'acervo';

  return (
    <Link to={`/${urlName}?categorias=${activity.categories.join(',')}${isNative ? 'isNative=true': ''}`}>
      <VStack
        height={'110px'}
        justify={'center'}
        align={'center'}
        borderRadius={'10px'}
        border="1px solid #ededed"
        minWidth={isMobile ? '200px' : '100%'}
        maxWidth={isMobile ? '200px' : '100%'}
        backgroundImage={`url(${activity.image})`}
        padding="20px"
        transition="transform 0.2s, box-shadow 0.2s"
        _hover={{
          transform: 'scale(1.05)',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        }}
      >
        <Heading
          textAlign={'center'}
          fontSize={'18px'}
          textShadow={'0px 0px 10px black'}
          color="white"
          textTransform={'capitalize'}
        >
          {activity.name.toLowerCase()}
        </Heading>
      </VStack>
    </Link>
  );
}
